import request from '@/utils/request'

export function cartList () {
    return request({
        url: 'cart/index',
        method: 'get',
        params: {}
    })
}

export function cartAdd (id, number) {
  return request({
    url: 'cart/add',
    method: 'POST',
    params: {
        id: id,
        number: number
    }
  })
}
export function cartUpdate (id, number) {
  return request({
    url: 'cart/update',
    method: 'POST',
    params: {
        id: id,
        number: number
    }
  })
}
export function cartDelete (ids) {
  return request({
    url: 'cart/delete',
    method: 'POST',
    params: {
        ids: ids,
    }
  })
}
export function cartFastadd (data) {
    return request({
      url: 'cart/fastadd',
      method: 'POST',
      params: data
    })
}